<template>
    <div>
        <!-- <b-field label="Current version" vertical>
            <b-input v-model="project.modelId" disabled></b-input>
        </b-field> -->
        <b-field label="Version" vertical>
            <b-field grouped message="Which version do you want to deploy?">
                <b-select expanded v-if="projectModels" placeholder="Select a model" 
                v-model="deployModel">
                    <option
                        v-for="(model, idx) in projectModels"
                        :value="model.id"
                        >
                        {{ model.id }}
                        <span v-if="'model_metrics' in model">
                            | {{(model.model_metrics["accuracy"]*100).toFixed(0)}}/100
                        </span>
                         | {{  model.createdAt.toDate().toDateString() }}
                    </option>
            </b-select>
            <b-select v-else expanded disabled placeholder="Not deployed yet">
                <option disabled>
                    No model version available yet
                </option>
            </b-select>
            <p class="control">
                <b-button @click="changeDeployModel" label="Deploy" type="is-primary" />
            </p>
            </b-field>
            
        </b-field>
        <b-field label="Endpoint" vertical>
            {{  inferenceUrl }}
        </b-field>
        <b-field label="Status" vertical>
            The operational status is&nbsp;<b>online</b>&nbsp;(<a href="https://status.metatext.io/" target="_blank">see status page</a>)
        </b-field>
        <b-field label="Docs and guides" vertical>
            <a href="https://metatext.ai/documentation/api" target="_blank">See the Metatext API docs and guides</a>
        </b-field>
        <b-field label="API Key" vertical>
            {{ apiKey }}
        </b-field>
        <b-field label="Inference cURL Command" vertical>
            <b-notification style="background: #222;" :closable="false">
                                <code style="color: #f1f1f1; background: #222;">$ curl --request POST \<br>
            --url {{ inferenceUrl }} \<br>
            --header 'content-type: application/json' \<br>
            --header 'x-api-key: {{ apiKey }}' \<br>
            --data '{"text": "hello world",
                     "version": "{{ this.project.modelId }}"
                     
            }'</code>
                                </b-notification>
        </b-field>

        
        
    </div>
</template>
<script>

   export default {
     props: ["models", "project", "apiKey", "inferenceUrl"],
     name: "DeployInfo",
     data: function() {
        return {
            deployModel: (this.project.productionVersionId ? this.project.productionVersionId : this.project.modelId),
            deployment_model_base_url: 'https://api.metatext.ai/v1/inference/',
            deployment_model_base_url_answering: 'https://api.metatext.ai/v1/answering/',
            all_users_api_key: 'LoU6v3NmsR3aFg4LgrU6g7FKCHR4CfJS8bkAZci6'
        }
    },
    computed: {
        projectModels(){
            return this.$store.state.projectModels
        }
     },
     methods: {
        updateModelVersion(){
            const toUpdate = {
                projectId: this.project.id,
                update: {
                    productionModelId: this.deployModel
                }
            }
            this.$store.dispatch("updateProject", 
                toUpdate
            );
        },
        changeDeployModel(){
            this.$buefy.dialog.confirm({
                message: `Please confirm to deploy the version: \n\n<b>${this.deployModel}</b>`,
                onConfirm: () => this.updateModelVersion()
            })
        }
     },
     mounted(){
        this.$store.dispatch("projectModels", this.project.id);

        
     },
     created(){
        
        this.$store.dispatch("projectModels", this.project.id)
     }
   }
</script>